import { SC_InvValid } from "../etech/SC_InvValid";
import { SC_Input } from "../input/SC_Input";
import { ReportReturnType } from "../report/ReportReturnType";
import { WR } from "../wr/WR";
import { WRString } from "./WRString";
import { WREingang } from "./WREingang";
import { ReturnTypeError } from "../utilities/ReturnTypeError";
import { TranslateService } from "../variables/translate-service";

export class SC_Inv {
	constructor(private translate: TranslateService, private scInvalid: SC_InvValid) { }

	public static getModCnt(): number {
		var i: number;
		var iRet: number;
		var wrTmp: WR;
		iRet = 0;
		for (i = 0; i < SC_Input.aInvAssign.length; i++) {
			wrTmp = SC_Input.aInvAssign[i];
			iRet += wrTmp.getModCnt();
		}
		return iRet;
	}

	public static getStrCnt(): number {
		var wrTmp: WR;
		var iRet: number;
		iRet = 0;
		SC_Input.aInvAssign.forEach(wrTmp => {
			iRet += wrTmp.getStrCnt();
		});
		return iRet;
	}

	public isValid(): ReportReturnType {
		var wrTmp: WR;
		var wreingangTmp: WREingang;
		var rteRet: ReturnTypeError;
		var wrstringTmp: WRString;
		var rrtRet: ReportReturnType;
		var i: number;
		for (i = 0; i < SC_Input.aInvAssign.length; i++) {
			wrTmp = SC_Input.aInvAssign[i];
			for (i = 0; i < wrTmp.aEingang.length; i++) {
				if (wrTmp.aEingang[i].aString.length == 0) {
					wrstringTmp = wrTmp.aEingang[i].aString[0];
					rrtRet = this.scInvalid.isValid(wrTmp, SC_Input.moduniqueCurrentMod, wrstringTmp.iModCnt, wrTmp.aEingang[i].aString.length);
					if (!rrtRet.bValue) {
						rrtRet.sIssue = this.translate.getLng('PAR_GEN') + " " + (i + 1).toString() + ": " + rrtRet.sIssue;
						return rrtRet;
					}
				}
			};
		}
		rrtRet = new ReportReturnType();
		rrtRet.bValue = true;
		return rrtRet;
	}
}